export const siteTitle = "The Mayoral Tutorial";